import { render } from "./g-prototyp-page.vue?vue&type=template&id=828d9958&ts=true"
import script from "./g-prototyp-page.vue?vue&type=script&lang=tsx"
export * from "./g-prototyp-page.vue?vue&type=script&lang=tsx"

import "./g-prototyp-page.vue?vue&type=style&index=0&id=828d9958&lang=css"

import exportComponent from "D:\\Visual Studio\\Projects\\Web\\GGDev.Web.ThePortal\\GGDev.Web.ThePortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__